import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  RaisedButton,
  FlatButton,
  Stepper,
  Step,
  StepLabel,
  Checkbox, FontIcon,
} from 'material-ui';
import R from 'ramda';
import SignupForm from '../../../contracting-sign-up/signup-form';
import SignupButton from '../../../contracting-sign-up/signup-button';
import UploadFiles from './upload-files';
import SelectRequests from './select-requests';
import injectStyleSheet from 'react-jss';
import LoadingOverlay from '../../../tc-ui/loading-overlay';

const propTypes = {
  signupFn: PropTypes.func,
  classes: PropTypes.object,
  updateDialogProps: PropTypes.func,
  allRequests: PropTypes.array,
  files: PropTypes.array,
  hasAccount: PropTypes.bool,
  requestEzLoad: PropTypes.func,
  addingToQ: PropTypes.bool,
  ezloadAddedToQ: PropTypes.bool,
  wrongAccountType: PropTypes.bool,
};

const styles = {
  stepContent: { padding: '16px 32px', paddingTop: 0 },
  dropZone2: {
    display: 'flex',
    border: '4px dashed rgb(239, 239, 239) !important',
    padding: '8px',
    clear: 'both',
    minHeight: '100px',
    alignItems: 'center',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.44)',
  },
  centerText: {
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
  },
  signUpStep: {
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
  },
};

class DLWizardContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 1,
    };
  }
  componentWillMount() {

  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  onCheckTerm = () => {
    this.setState({ termChecked: !this.state.termChecked, error: '' });
  };

  onCheckRequest = obj => (_, checked) => {
    const {
      updateDialogProps,
      allRequests = [],
    } = this.props;
    const duplicateRequest = checked &&
      allRequests.some(request => request.checked
        && (obj.startDate !== request.startDate
        || obj.endDate !== request.endDate)
      );
    if (duplicateRequest) {
      this.setState({ error: 'You can only select requests with the same contracting period.' });
    } else {
      this.setState({ error: '' });
      updateDialogProps({
        allRequests: allRequests.map(request => {
          if (request._id === obj._id) return R.assoc('checked', checked, request);
          return request;
        }),
      });
    }
  };

  updateFileList = (files) => {
    this.setState({ error: '' });
    this.props.updateDialogProps({ files });
  };

  removeFile = i => () => {
    this.props.updateDialogProps({ files: R.remove(i, 1, this.props.files) });
  };
  goPrev = () => this.setState({ activeStep: this.state.activeStep - 1 });

  goNext = () => {
    const {
      activeStep,
    } = this.state;
    const {
      files = [],
    } = this.props;
    if (activeStep === 1) {
      if (!files.length) {
        this.setState({ error: 'Please upload at least one file.' });
      } else {
        this.setState({ activeStep: 2 });
      }
    }

    if (activeStep === 2) {
      this.checkRequestsStepValid(() => this.setState({ activeStep: 3, error: '' }))();
    }
  };

  checkRequestsStepValid = fn => () => {
    const {
      termChecked,
    } = this.state;
    if (!termChecked) {
      this.setState({ error: 'Please accept the term in order to continue.' });
    } else {
      fn();
    }
  };

  requestEzLoad = () => {
    this.checkRequestsStepValid(this.props.requestEzLoad)();
  }
  render() {
    const {
      signupFn,
      addingToQ,
      ezloadAddedToQ,
      classes: css,
      files = [],
      allRequests = [],
      hasAccount,
      wrongAccountType,
    } = this.props;
    const { activeStep, error, termChecked } = this.state;
    const steps = ['Upload Rates Files', 'Select Buyers'];
    if (!hasAccount || wrongAccountType) steps.push('Create an account');
    if (ezloadAddedToQ) {
      return (
        <div className={css.centerText}>
          <FontIcon className="tc-icon-paperplane" color="#00bcd4" style={{ fontSize: '128px' }} />
          <br/>
          <h4 >Thank you for submitting your rates to be loaded.</h4>
          <div>
            {`We will send you notifications as we go through the process of loading your rates. We may also contact you for additional rate-related information.\n\n`}
          </div>
          If you have any questions, please do not hesitate to ask our team at <a href="mailto:support@tourconnect.com">support@tourconnect.com</a>
          <br/>
          <br/>
        </div>
      );
    }
    return (
      <div>
        <Stepper activeStep={activeStep - 1}>
          {
            steps.map(step => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))
          }
        </Stepper>
        <div className={css.stepContent}>
          {(() => {
            if (activeStep === 1) {
              return (
                <UploadFiles
                  forDL
                  files={files}
                  css={css}
                  removeFile={this.removeFile}
                  updateFileList={this.updateFileList}
                />
              );
            }
            if (activeStep === 2) {
              return (
                <div>
                  <SelectRequests
                    requests={allRequests}
                    onCheckRequest={this.onCheckRequest}
                  />
                  <Checkbox
                    style={{ margin: '32px 16px' }}
                    label="I understand that I will be required to thoroughly review the rates loaded by TourConnect, and I will be responsible for the accuracy of the rates I approve and send to my partners."
                    checked={termChecked}
                    onCheck={this.onCheckTerm}
                  />
                </div>
              );
            }
            if (activeStep === 3) {
              return (<div className={css.signUpStep}>
                <div>
                  Once your rates are loaded, you will need to have a secure login to review, approve, and send your rates. Please create a login now.
                  <br/><br/>
                  * Please note, we cannot load your rates for you, if you do not create a secure login where we can store your rates.
                </div>
                <SignupForm />
              </div>);
            }
          })()}
        </div>
        <div className="flex-tc-sb">
          {
            activeStep > 1 ? (
              <FlatButton
                secondary
                label="Previous"
                onTouchTap={this.goPrev}
              />
            ) : <div/>
          }
          <div style={{ color: 'red' }}>
            {error}
          </div>
          {
            (() => {
              const disabled = (() => {
                if (activeStep === 1) {
                  return !files.length;
                }
                if (activeStep === 2) {
                  return !termChecked;
                }
                return addingToQ;
              })();
              if (activeStep === 1) {
                return (
                  <RaisedButton
                    secondary
                    disabled={disabled}
                    label="Next"
                    onTouchTap={this.goNext}
                  />
                );
              }
              if (activeStep === 3) {
                return (
                  <SignupButton
                    signupFn={signupFn}
                  />
                );
              }
              // when step 2
              if (!hasAccount || wrongAccountType) {
                return (
                  <RaisedButton
                    secondary
                    disabled={disabled}
                    label="Next"
                    onTouchTap={this.goNext}
                  />
                );
              }
              return (
                <RaisedButton
                  labelStyle={{ color: '#fff' }}
                  primary
                  label="Request EZ Load"
                  disabled={disabled}
                  onTouchTap={this.requestEzLoad}
                />
              );
            })()
          }
        </div>
        <LoadingOverlay loading={addingToQ} />
      </div>
    );
  }
}

const mapStateToProps = ({}) => ({

});

const mapDispatchToProps = dispatch => ({

});
DLWizardContainer.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(injectStyleSheet(styles)(DLWizardContainer));



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/dialog/wizards/dl-wizard-container.jsx